
import { Card, CardContent } from "@/components/ui/card";
import { Package, Users, Target, Award } from "lucide-react";
import { Link } from "react-router-dom";

const About = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 to-white">
      {/* Header */}
      <header className="bg-white shadow-sm">
        <div className="container mx-auto px-4 py-4 flex justify-between items-center">
          <Link to="/" className="flex items-center space-x-2">
            <Package className="h-8 w-8 text-purple-600" />
            <span className="text-2xl font-bold text-gray-900">OrderEase</span>
          </Link>
          <Link to="/" className="text-purple-600 hover:text-purple-700">
            Back to Home
          </Link>
        </div>
      </header>

      <div className="container mx-auto px-4 py-16">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h1 className="text-4xl font-bold text-gray-900 mb-4">About OrderEase</h1>
            <p className="text-xl text-gray-600">
              Empowering Etsy sellers with powerful tools to manage and grow their businesses.
            </p>
          </div>

          {/* Mission */}
          <Card className="mb-8">
            <CardContent className="p-8">
              <div className="flex items-center mb-4">
                <Target className="h-8 w-8 text-purple-600 mr-3" />
                <h2 className="text-2xl font-bold">Our Mission</h2>
              </div>
              <p className="text-gray-700 leading-relaxed">
                At OrderEase, we believe that every Etsy seller deserves access to professional-grade 
                tools that help them manage their orders efficiently and grow their business. We're 
                dedicated to simplifying the complex process of order management, analytics, and 
                customer relationship management for creative entrepreneurs worldwide.
              </p>
            </CardContent>
          </Card>

          {/* Values */}
          <div className="grid md:grid-cols-3 gap-6 mb-12">
            <Card className="text-center">
              <CardContent className="p-6">
                <Users className="h-12 w-12 text-purple-600 mx-auto mb-4" />
                <h3 className="text-xl font-semibold mb-2">Customer First</h3>
                <p className="text-gray-600">
                  We prioritize our users' success and build features that truly matter to their business growth.
                </p>
              </CardContent>
            </Card>
            
            <Card className="text-center">
              <CardContent className="p-6">
                <Package className="h-12 w-12 text-purple-600 mx-auto mb-4" />
                <h3 className="text-xl font-semibold mb-2">Simplicity</h3>
                <p className="text-gray-600">
                  Complex problems deserve simple solutions. We make order management intuitive and accessible.
                </p>
              </CardContent>
            </Card>
            
            <Card className="text-center">
              <CardContent className="p-6">
                <Award className="h-12 w-12 text-purple-600 mx-auto mb-4" />
                <h3 className="text-xl font-semibold mb-2">Excellence</h3>
                <p className="text-gray-600">
                  We strive for excellence in everything we do, from product design to customer support.
                </p>
              </CardContent>
            </Card>
          </div>

          {/* Story */}
          <Card className="mb-8">
            <CardContent className="p-8">
              <h2 className="text-2xl font-bold mb-4">Our Story</h2>
              <div className="space-y-4 text-gray-700">
                <p>
                  OrderEase was born from the frustration of managing a growing Etsy business. Our founder, 
                  a successful Etsy seller, spent countless hours juggling spreadsheets, tracking orders 
                  manually, and struggling to understand business performance.
                </p>
                <p>
                  After realizing that thousands of other sellers faced the same challenges, we decided 
                  to build the solution we wished existed. OrderEase combines powerful order management, 
                  insightful analytics, and seamless Etsy integration into one easy-to-use platform.
                </p>
                <p>
                  Today, we're proud to serve thousands of Etsy sellers worldwide, helping them save time, 
                  reduce stress, and focus on what they do best - creating amazing products and delighting customers.
                </p>
              </div>
            </CardContent>
          </Card>

          {/* Call to Action */}
          <div className="text-center">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Ready to Transform Your Business?</h2>
            <p className="text-xl text-gray-600 mb-6">
              Join thousands of successful Etsy sellers who trust OrderEase to manage their orders.
            </p>
            <Link 
              to="/signup" 
              className="inline-block bg-purple-600 hover:bg-purple-700 text-white font-semibold px-8 py-3 rounded-lg transition-colors"
            >
              Get Started Today
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
